import { InternalTransactions } from '../types';

type InternalTransactionsName =
  (typeof InternalTransactions)[keyof typeof InternalTransactions];

export type CustomTransactionName<T extends string> =
  T extends InternalTransactionsName ? never : T;

export const isCustomTransactionName = (
  name: InternalTransactionsName | string,
) =>
  !Object.values(InternalTransactions).includes(
    name as InternalTransactionsName,
  );
